import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyNotificationErrorState = lazy(() => import('./svg-components/notification-error-state'));

const NotificationErrorState = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyNotificationErrorState {...rest} />
  </Suspense>
);

export default NotificationErrorState;
